"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrueHitStepsRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.TrueHitStepsRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.true_hit_steps.label',
    fallbackLabel: 'True hit handling steps',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'PROCESSES_SUPPORTING_IDENTIFICATION_OF_A_TRUE_SANCTIONS_HIT', label: 'fields.enm.true_hit_steps.options.PROCESSES_SUPPORTING_IDENTIFICATION_OF_A_TRUE_SANCTIONS_HIT', fallbackLabel: 'Processes supporting identification of a true sanctions hit' },
        { key: 'BLOCKING_AND_REJECTING_CUSTOMER_OR_TRANSACTION', label: 'fields.enm.true_hit_steps.options.BLOCKING_AND_REJECTING_CUSTOMER_OR_TRANSACTION', fallbackLabel: 'Blocking and rejecting customer or transaction' },
        { key: 'INTERNAL_ESCALATION_PROCESSES', label: 'fields.enm.true_hit_steps.options.INTERNAL_ESCALATION_PROCESSES', fallbackLabel: 'Internal escalation processes' },
        { key: 'EXTERNAL_ESCALATION_PROCESSES', label: 'fields.enm.true_hit_steps.options.EXTERNAL_ESCALATION_PROCESSES', fallbackLabel: 'External escalation processes (reporting to authorities) when required' },
        { key: 'NONE', label: 'fields.enm.true_hit_steps.options.NONE', fallbackLabel: 'None of the above' },
    ],
    trackFieldValueWithAnalytics: false,
};
